import IResource from '../resource';
import { IRestriction } from '../user/restriction';

export const UPLOADER_APPLICATION_ID: string = "10";

/**
 * Represents a Basepace app.
 */
export interface IApplication extends IResource {
    DatePublished?: string;
    HrefLogo?: string;
    HrefStoreVersion?: string;
    HrefUserVersion?: string;
    Category?: string;
    Classifications?: string[];
    ClientId?: string;
    CompanyName?: string;
    PublishStatus?: string;
    VersionNumber?: string;
    VersionLabel?: string;
    WhatsNew?: string;
    ReleaseNotes?: string;
    ShortDescription?: string;
    LongDescription?: string;
    IsBillingActivated?: boolean;
    Features?: string[];
    IsFree?: boolean;
    ComputeCostPerMinute?: number;
    AppFamilySlug?: string;
    AppVersionSlug?: string;
    Bookmarked?: boolean;
    LockStatus?: string;
    WorkflowSourceApplication?: IApplication;
    AppLaunchRestriction?: IRestriction;
    CostDetails?: string;
}

export interface IApplicationScreenshots {
  Items?: string[];
}

export interface IApplicationSearchParams {
  text: string;
  classification: IApplicationClassification
}

export interface IApplicationClassification {
  Name: string;
  Description: string;
  Id?: string
}

export interface IApplicationCategory {
  Name: string;
  Description: string;
}

